<template>
	<Dialog :visible="visible" @update:visible="emit('update:visible', $event)" :modal="true" :closable="!loading"
		:draggable="false" :style="{ width: '480px', maxWidth: '95vw' }" class="submit-confirm-dialog" @hide="onHide">
		<template #header>
			<div class="dialog-header">
				<div>
					<i class="pi pi-send"></i>
				</div>
				<div>
					<h3 class="dialog-title">Konfirmasi Submit</h3>
					<p class="dialog-subtitle">Sinkronisasi email ke sistem Snap</p>
				</div>
			</div>
		</template>

		<div class="dialog-body">
			<p class="dialog-lead">
				Anda akan mensubmit email berikut. User di Snap akan menggunakan email
				ini untuk notifikasi dan komunikasi transaksi.
			</p>

			<div class="info-card">
				<div class="info-row">
					<div class="info-label">
						<i class="pi pi-building"></i>
						<span>Vendor</span>
					</div>
					<div class="info-value">{{ vendorName || '-' }}</div>
				</div>
				<div class="info-divider"></div>
				<div class="info-row">
					<div class="info-label">
						<i class="pi pi-briefcase"></i>
						<span>Company</span>
					</div>
					<div class="info-value">{{ companyName || '-' }}</div>
				</div>
				<div class="info-divider"></div>
				<div class="info-row info-row-highlight">
					<div class="info-label">
						<i class="pi pi-envelope"></i>
						<span>Email</span>
					</div>
					<div class="info-value email-value">{{ email || '-' }}</div>
				</div>
			</div>

			<div class="notice-box">
				<i class="pi pi-info-circle notice-icon"></i>
				<span>
					Pastikan email sudah benar. Perubahan setelah submit akan
					memengaruhi seluruh user Snap terkait vendor ini.
				</span>
			</div>
		</div>

		<template #footer>
			<div class="dialog-footer">
				<Button label="Batal" icon="pi pi-times" class="p-button-outlined p-button-secondary" @click="onCancel"
					:disabled="loading" />
				<Button label="Ya, Submit" icon="pi pi-check" class="p-button-primary submit-btn" @click="onConfirm"
					:loading="loading" />
			</div>
		</template>
	</Dialog>
</template>

<script setup>
// eslint-disable-next-line no-undef
defineProps({
	visible: {
		type: Boolean,
		default: false,
	},
	vendorName: {
		type: String,
		default: '',
	},
	companyName: {
		type: String,
		default: '',
	},
	email: {
		type: String,
		default: '',
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const onConfirm = () => emit('confirm');
const onCancel = () => {
	emit('update:visible', false);
	emit('cancel');
};
const onHide = () => emit('update:visible', false);
</script>

<style scoped>
.dialog-header {
	display: flex;
	align-items: center;
	gap: 14px;
}

.dialog-header-icon {
	width: 48px;
	height: 48px;
	border-radius: 12px;
	background: linear-gradient(135deg, #4a90d9 0%, #2ecc71 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	box-shadow: 0 4px 12px rgba(74, 144, 217, 0.35);
}

.dialog-header-icon i {
	font-size: 1.25rem;
	color: #fff;
}

.dialog-title {
	margin: 0;
	font-size: 1.15rem;
	font-weight: 700;
	color: #1a1a2e;
	line-height: 1.3;
}

.dialog-subtitle {
	margin: 2px 0 0;
	font-size: 0.82rem;
	color: #888;
}

.dialog-body {
	padding-top: 4px;
}

.dialog-lead {
	margin: 0 0 16px;
	font-size: 0.9rem;
	color: #555;
	line-height: 1.55;
}

.info-card {
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	padding: 4px 16px;
	margin-bottom: 16px;
}

.info-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	padding: 12px 0;
}

.info-row-highlight {
	background: linear-gradient(90deg, rgba(74, 144, 217, 0.06) 0%, rgba(46, 204, 113, 0.06) 100%);
	margin: 0 -16px;
	padding: 12px 16px;
	border-radius: 0 0 10px 10px;
}

.info-label {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 0.82rem;
	font-weight: 600;
	color: #64748b;
	flex-shrink: 0;
}

.info-label i {
	font-size: 0.85rem;
	color: #4a90d9;
}

.info-value {
	font-size: 0.88rem;
	font-weight: 500;
	color: #1e293b;
	text-align: right;
	word-break: break-all;
}

.email-value {
	color: #2563eb;
	font-weight: 600;
}

.info-divider {
	height: 1px;
	background: #e2e8f0;
}

.notice-box {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	background: #fffbeb;
	border: 1px solid #fde68a;
	border-radius: 8px;
	padding: 12px 14px;
	font-size: 0.82rem;
	color: #92400e;
	line-height: 1.5;
}

.notice-icon {
	font-size: 1rem;
	margin-top: 1px;
	flex-shrink: 0;
	color: #d97706;
}

.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	width: 100%;
}

.submit-btn {
	min-width: 130px;
}
</style>

<style>
.submit-confirm-dialog .p-dialog-header {
	padding: 1.25rem 1.5rem 0.75rem;
	border-bottom: none;
}

.submit-confirm-dialog .p-dialog-content {
	padding: 0 1.5rem 1rem;
}

.submit-confirm-dialog .p-dialog-footer {
	padding: 0 1.5rem 1.25rem;
	border-top: none;
}

.submit-confirm-dialog .p-dialog {
	border-radius: 14px;
	overflow: hidden;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
</style>
